import { darken } from 'polished';
import styled from 'styled-components';

import colors from '../../styles/colors';

export const Container = styled.footer`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: ${colors.white};
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  div {
    a {
      text-decoration: underline;
      color: ${colors.blue};
      font-size: 11px;
      &:first-child {
        margin-right: 30px;
      }
      &:hover {
        color: ${darken(0.3, `${colors.blue}`)};
      }
    }
  }
`;
